import PageContainer from '@/components/layout/page-container';
import { Heading } from '@/components/ui/heading';
import { useAuthStore } from '@/store/auth';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import ProjectsTable from '@/modules/projects/projects-table';

export default function ProjectPage() {
  const context = useAuthStore((state) => state.context);

  return (
    <PageContainer scrollable={true}>
      <div className='mb-5 flex items-center justify-between px-4'>
        <Heading title='Projects' description={''} />
        {context === 'organisation' && (
          <Link to={`/dashboard/projects/add`} >
            <Button id='add-projects'>Add Projects</Button>
          </Link>
        )}
      </div>
      
      <div className='h-full space-y-4 bg-white py-3'>
        <ProjectsTable />
      </div>
    </PageContainer>
  );
}
